import { PAGES } from "@dune/types";
import { DesignerToSubmissionFormData } from "@dune/types";
import { useEffect } from "react";
import { FormProvider } from "react-hook-form";
import { useNavigate, useParams, useSearchParams } from "react-router-dom";
import { useAddDesignerParticipant } from "../../../../api/mutations/constructionSiteSubmission.mutations";
import { DesignerToSubmissionForm } from "../../../../component/constructionSites/submission/participants/DesignerToSubmissionForm";
import PageLayoutWithTabs from "../../../../component/layout/PageLayoutWithTabs";
import { useEntityPanelSync } from "../../../../hooks/useEntityPanelSync";
import { useDesignerToSubmissionForm } from "../../../../hooks/useParticipantToSubmissionForm";

export const AddDesignerToSubmissionPage = () => {
	const navigate = useNavigate();
	const { constructionSiteId } = useParams<{ constructionSiteId: string }>();
	const [searchParams] = useSearchParams();
	const returnUrl = searchParams.get("returnUrl");

	const addDesignerMutation = useAddDesignerParticipant(
		constructionSiteId ? Number(constructionSiteId) : 0,
	);

	const onSubmit = (data: DesignerToSubmissionFormData) => {
		addDesignerMutation.mutate(data, {
			onSuccess: () => {
				if (constructionSiteId) {
					if (returnUrl) {
						navigate(returnUrl);
					} else {
						navigate(
							PAGES.PROJECTS.submission.withParams(constructionSiteId, 4),
						);
					}
				}
			},
		});
	};

	const onCancel = () => {
		if (constructionSiteId) {
			if (returnUrl) {
				navigate(returnUrl);
			} else {
				navigate(PAGES.PROJECTS.submission.withParams(constructionSiteId, 4));
			}
		}
	};

	const { form, handleSubmit } = useDesignerToSubmissionForm({
		mode: "add",
		onSubmit,
	});

	useEntityPanelSync({
		entityType: "CONSTRUCTION_SITE",
		entityId: constructionSiteId ? Number(constructionSiteId) : 0,
	});

	useEffect(() => {
		if (!constructionSiteId) {
			navigate(PAGES.PROJECTS.index);
		}
	}, [constructionSiteId, navigate]);

	if (!constructionSiteId) {
		return null;
	}

	return (
		<PageLayoutWithTabs title="Ajouter un concepteur">
			<FormProvider {...form}>
				<form onSubmit={handleSubmit}>
					<DesignerToSubmissionForm
						constructionSiteId={Number(constructionSiteId)}
						onSubmit={handleSubmit}
						onCancel={onCancel}
						isSubmitting={addDesignerMutation.isPending}
					/>
				</form>
			</FormProvider>
		</PageLayoutWithTabs>
	);
};
